import React from 'react';

import shudipto from '../../../images/shudipto3.png';
import Typewriter from 'typewriter-effect';

const Header = () => {
    return (
        <div id="home" className="w-10/12 lg:w-full mx-auto flex flex-col-reverse lg:flex-row justify-center  gap-4 text-white font-titillium py-5 pt-32 -mt-24">

            <div className="lg:w-96 lg:h-96 mx-auto border-8 rounded-full border-gray-400">
                <img src={shudipto}
                    className="w-full h-full rounded-full filter grayscale" />
            </div>
            <div className="w-full text-justify lg:w-4/12 mx-auto flex flex-col items-start justify-around  lg:py-16" >

                <Typewriter
                    options={{
                        strings: ['Web Developer', 'Software Engineer'],
                        autoStart: true,
                        loop: true,
                    }}
                />

                <h3 className="font-concertone text-4xl my-2">Shudipta Das</h3>

                <p className="font-concertone font-light text-sm">A Professional Web Designer and Imaginative Developer. Strong attention to small details.</p>


                <a href="Resume-Shudipta.pdf" target="_blank"
                    className="border-2 cursor-pointer border-red-700 bg-transparent my-4 px-4 py-4 font-serif hover:bg-red-700 text-white"
                >Download Resume</a>
            </div>

        </div>
    );
};

export default Header;